import { Box, Flex, Heading, Text } from '@radix-ui/themes'
import Logo from '../assets/images/mango-logo.png'
import LoginForm from '../components/auth/LoginForm'
import { useEffect } from 'react'
import { useSelector } from 'react-redux';

const Login = () => {
    const user = useSelector(state => state.user);
    const account = useSelector(state => state.account);
    const authToken = localStorage.getItem('authToken')

    // useEffect(() => {
    //     const isAuthenticated = user?.details && account?.details && authToken;
    //     if (isAuthenticated) {
    //         window.location.href = '/';
    //     }
    // }, [])

    return (
        <Flex direction="column" gap="4" align="center" justify="center" style={{ minHeight: '100vh' }}>
            <Box style={{ width: '100%', maxWidth: '400px' }}>
                <Flex direction="column" justify="center" align="center" mb="4">
                    <Flex justify="center" align="center" mb="8"><img width={200} src="/edusua.svg" alt="Logo" /></Flex>
                    {/* <Text size="4" mb="2">Log in to your account</Text> */}
                    <Text as="h3" size="2">Welcome back! Please enter your details.</Text>
                </Flex>
                <LoginForm />
            </Box>
        </Flex>
    )
}

export default Login

